import { colorHeadings, fontSans } from '../theme/config';
import { injectGlobal, keyframes } from 'styled-components';
import media from '../theme/media';

/* eslint-disable */

const fadeInHome = keyframes `
  from { opacity: 0; }
  to { opacity: 1; }
`;

const fadeInSkwiz = keyframes `
  from { opacity: 0; }
  to { opacity: 1; }
`;

injectGlobal`
  @import url('https://fonts.googleapis.com/css?family=IBM+Plex+Mono:600,700&display=swap');
  @import url('https://fonts.googleapis.com/css?family=IBM+Plex+Sans:400,700&display=swap');
  
  @@font-face {
    font-family: 'Inter';
    font-style:  normal;
    font-weight: 400;
    src: url("../fonts/Inter/Inter-Regular.woff2") format("woff2"),
         url("../fonts/Inter/Inter-Regular.woff") format("woff");
  }


  @@font-face {
    font-family: 'Inter';
    font-style:  normal;
    font-weight: 500;
    src: url("../fonts/Inter/Inter-Medium.woff2") format("woff2"),
         url("../fonts/Inter/Inter-Medium.woff") format("woff");
  }


  @@font-face {
    font-family: 'Inter';
    font-style:  normal;
    font-weight: 600;
    src: url("../fonts/Inter/Inter-SemiBold.woff2") format("woff2"),
         url("../fonts/Inter/Inter-SemiBold.woff") format("woff");
  }

  @@font-face {
    font-family: 'Inter';
    font-style:  normal;
    font-weight: 700;
    src: url("../fonts/Inter/Inter-Bold.woff2") format("woff2"),
         url("../fonts/Inter/Inter-Bold.woff") format("woff");
  }

  * {
    border: 0;
    box-sizing: border-box;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-smoothing: antialiased;
    margin: 0;
    outline: 0;
    padding: 0;
    text-decoration: none;
    text-rendering: optimizeLegibility;
  }

  svg * {
    -webkit-transform-origin: center center 0;
    -ms-transform-origin: center center 0;
    transform-origin: center center 0;
  }
  
  @import url('https://rsms.me/inter/inter.css');
  html { font-family: ${fontSans} }
  @supports (font-variation-settings: normal) {
    html { font-family: 'Inter var', sans-serif; }
  }

  body {
    color: #525252;
    font-family: ${fontSans};
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: 400;
    //font-size: 1.125rem;
    //line-height: 1.6875rem;
    width: 100vw;
    overflow-x: hidden;
  }

  a {
    color: inherit;
    font-family: ${fontSans};
  }

  h1, h2, h3, h4, h5 {
    color: ${colorHeadings};
    font-family: ${fontSans};
    font-weight: 700;
  }

  h1 {
    font-size: 2rem;
  }

  h2 {
    margin: 0 0 1.5rem 0;
    font-size: 1.5rem;
    line-height: 2rem;
  }

  h3 {
    margin: 0 0 .5rem 0;
  }

  h4 {
    display: inline-block;
    letter-spacing: 1px;
    line-height: 24px;
    margin: 0 0 .5rem 0;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: bold;
  }

  p {
    margin-bottom: 1.125rem;
  }

  ul {
    ${media.small`margin: 0 0 1rem 1rem;`}
  }

  img {
    width: 100%;
  }
  
  @keyframes fadeIn{
  0%, 49% {
    opacity:0;
  }
  100% {
    opacity:1;
  }
}
  
  .default {
    animation: ${fadeInHome} 1s;
    ${media.tablet`
      img#contactIllo {
        opacity: 1;
      }
    `}
  }
  
  .skwizImage {
    .skwizIllo {
      animation: ${fadeInSkwiz} .5s forwards;
    }
    ${media.tablet`
      .backgroundImage {
        display: none;
      }
      img.skwizLogo {
        opacity: 0;
      }
    `}
  }
  
  .skwiz2Image {
    .skwiz2Illo {
      animation: ${fadeInSkwiz} .5s forwards;
    }
    ${media.tablet`
      .backgroundImage {
        display: none;
      }
      img.skwizLogo {
        opacity: 0;
      }
    `}
  }
  
  .amazonImage {
    .amazonIllo {
      animation: ${fadeInSkwiz} .5s forwards;
    }
    ${media.tablet`
      .backgroundImage {
        display: none;
      }
      img.skwizLogo {
        opacity: 0;
      }
    `}
  }
  
  .amazon2Image {
    .amazon2Illo {
      animation: ${fadeInSkwiz} .5s forwards;
    }
    ${media.tablet`
      .backgroundImage {
        display: none;
      }
      img.skwizLogo {
        opacity: 0;
      }
    `}
  }
    
  .mozillaImage {
    .mozillaIllo  {
      animation: ${fadeInSkwiz} .5s forwards;
    }
    ${media.tablet`
      .backgroundImage {
        display: none;
      }
      img.mozillaIllo {
        opacity: 0;
      }
    `}
  }
  
  .mozilla2Image {
    .mozilla2Illo  {
      animation: ${fadeInSkwiz} .5s forwards;
    }
    ${media.tablet`
      .backgroundImage {
        display: none;
      }
      img.mozilla2Illo {
        opacity: 0;
      }
    `}
  }
  
  .everyactionImage {
    .everyactionIllo {
      animation: ${fadeInSkwiz} .5s forwards;
    }
    ${media.tablet`
      .backgroundImage {
        display: none;
      }
      img.everyactionIllo {
        opacity: 0;
      }
    `}
  }
  
  .everyaction2Image {
    .everyaction2Illo {
      animation: ${fadeInSkwiz} .5s forwards;
    }
    ${media.tablet`
      .backgroundImage {
        display: none;
      }
      img.everyaction2Illo {
        opacity: 0;
      }
    `}
  }
  
  .contactImage {
    .contactIllo {
      animation: ${fadeInSkwiz} .5s forwards;
    }
    ${media.tablet`
      .backgroundImage {
        display: none;
      }
    `}
  }
  
  .contact2Image {
    .contact2Illo {
      animation: ${fadeInSkwiz} .5s forwards;
    }
    ${media.tablet`
      .backgroundImage {
        display: none;
      }
    `}
  }
`



// WEBPACK FOOTER //
// src/theme/globalStyles.js